import React from 'react';
import { EnumCellProps, WithClassname } from '@jsonforms/core';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export const MuiAutoComplete = React.memo(
  (props: EnumCellProps & WithClassname & { hideLabel?: boolean }) => {
    const {
      data,
      className,
      id,
      // @ts-ignore
      label,
      enabled,
      path,
      handleChange,
      options,
      uischema,
    } = props;

    const onChange = (ev: any, target: any) => {
      let value = '';
      if (target === '' || target === undefined || !target) {
        value = 'None';
      } else {
        value = target.value;
      }
      handleChange(path, value);
    };

    const options_list = options ? options : [{ label: 'None', value: 'None' }];

    return (
      <Autocomplete
        options={options_list}
        id={id}
        onChange={onChange}
        disabled={!enabled}
        data-testid={id}
        value={
          options_list.find(opt => opt.value === data) || {
            label: 'None',
            value: 'None',
          }
        }
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={option => option.label}
        renderInput={params => (
          <div className={className}>
            <TextField
              label={uischema?.options?.newLabelName || label}
              {...params}
              sx={{
                '& .MuiInputBase-input.Mui-disabled': {
                  opacity: 1,
                  WebkitTextFillColor: 'rgba(0,0,0,.87) !important',
                  color: 'rgba(0,0,0,.87) !important',
                },
              }}
            />
          </div>
        )}
      />
    );
  },
);
